import { Badge } from "@/components/ui/badge";
import { Gem, Key } from "lucide-react";
import Image from "next/image";

const PointsBadge = ({
  className = "",
  points,
  completed,
}: { className?: string; points?: number; completed?: boolean }) => {
  if (!points || points === 0) {
    return null;
  }
  return (
    <Badge
      className={className}
      variant={completed ? "completed" : "outline"}
      startIcon={
        <Image
          src="/assets/task-list/points.png"
          alt="Points"
          width={20}
          height={20}
          className="object-contain w-5 h-5"
        />
      }
    >
      {points}
    </Badge>
  );
};

const GemsBadge = ({
  className = "",
  text,
  gems,
  completed,
}: {
  className?: string;
  text?: string;
  gems?: number;
  completed?: boolean;
}) => {
  if ((!gems || gems === 0) && !text) {
    return null;
  }
  return (
    <Badge
      className={className}
      variant={completed ? "completed" : "outline"}
      startIcon={<Gem className="w-4 h-4" />}
    >
      {text || gems}
    </Badge>
  );
};

const PerpetualRewardsBadge = () => {
  return (
    <div className="flex items-center gap-1">
      <Key className="w-3 h-3 text-[#99A8EA]" />
      <span className="text-xs bg-gradient-text bg-clip-text text-transparent font-normal leading-4">
        Eligible for Perpetual Rewards
      </span>
    </div>
  );
};

export { PointsBadge, GemsBadge, PerpetualRewardsBadge };
